import SelectVKA from "../../../../src/client/katnh/widgets/SelectVKA.js";
import * as React from 'react';
export default {
  SelectVKA,
  React
};